// extracted by mini-css-extract-plugin
module.exports = {"content":"errorPageContent__content__2a817bce","title":"errorPageContent__title__2a817bce","image":"errorPageContent__image__2a817bce"};